module.exports = __webpack_public_path__ + "img/8.d37844e8.webp";